import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  data: null,
  loading: false,
};

export const getAnalyticsDashboard = createAsyncThunk(
  "dashboard/get-analytics",
  async (params, { dispatch }) => {
    try {
      const response = await axios.get("report/analytics-dashboard", {
        params,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAnalyticsDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAnalyticsDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action?.payload?.data?.data ?? null;
      })
      .addCase(getAnalyticsDashboard.rejected, (state) => {
        state.loading = false;
        state.data = null;
      });
  },
});

export default dashboardSlice.reducer;
